<template>
  <div style="width: 100%; height: 100%">
    <el-dialog
      title="音视频预警信息"
      :visible.sync="dialogVisible"
      width="70%"
      :center="true"
      :before-close="handleClose"
    >
      <span slot="title">
        <span>音视频预警信息</span>
        <el-tag type="danger">{{ powerStation }}</el-tag>
        <el-tag type="danger">{{ warningDeviceName }}</el-tag>
      </span>
      <el-row :gutter="10" style="height: 600px">
        <el-col :span="12">
          <div class="block">
            <el-image :src="audioVideoAlarmUrl" style="height: 626px">
              <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" style="height: 313px">
            <div slot="header" class="clearfix">
              <span>通讯信息</span>
              <!--              <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
            </div>
            <div style="">
              <el-tag
                style="margin-left: 30px; margin-bottom: 15px"
                v-for="(item, index) in stationInformation"
                key="index"
                >{{ item.username }}({{ item.phone }})</el-tag
              >
            </div>
            <!--<el-table :data="stationInformation" max-height="350" style="width: 100%;">-->
            <!--<el-table-column prop="username" label="联系人"></el-table-column>-->
            <!--<el-table-column prop="phone" label="电话"></el-table-column>-->
            <!--<el-table-column prop="email" label="邮件"></el-table-column>-->
            <!--</el-table>-->
          </el-card>
          <el-card class="box-card" style="height: 313px">
            <div slot="header" class="clearfix">
              <span>预案信息</span>
              <!--              <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
            </div>

            <div class="text item">
              <el-row :gutter="20">
                <el-col :span="18">
                  <div class="grid-content bg-purple">① 紧急联系电站人员通知处理</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="18">
                  <div class="grid-content bg-purple">② 将信息通知至分管领导</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="18">
                  <div class="grid-content bg-purple">③ 实时关注处理情况，发生不可控因素第一时间通知分管领导</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['audioVideoAlarm'],
  watch: {
    audioVideoAlarm: function (newVal, oldVal) {
      console.log('audioVideoAlarm')
      this.dialogVisible = (newVal && true) || false
      this.audioVideoAlarmUrl = newVal.audioVideoAlarmUrl || ''
      this.warningDeviceName = newVal.warningDeviceName || ''
      let si = newVal.stationInformation || []
      for (let i = 0; i < si.length; i++) {
        si[i].username = si[i].realName || si[i].username
        this.powerStation = si[i].name
      }
      this.stationInformation = si
    }
  },
  data() {
    return {
      dialogVisible: false,
      warningDeviceName: '',
      audioVideoAlarmUrl: '',
      powerStation: '',
      stationInformation: []
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/audioVideoAlarm.vue